"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-reports.disabled': 'Funkcja zaawansowanych raportów nie jest dostępna w Twoim obecnym planie.',
};
